interface Props {
	iconColor?: string;
	width?: string;
	height?: string;
}
const DownloadIcon = ({ iconColor = '#fff', width = '18', height = '18' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6 6L3.5 6C2.39543 6 1.5 6.89543 1.5 8L1.5 13.75C1.5 14.8546 2.39543 15.75 3.5 15.75L14.5 15.75C15.6046 15.75 16.5 14.8546 16.5 13.75L16.5 8C16.5 6.89543 15.6046 6 14.5 6L12 6"
			stroke={iconColor}
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
		<path
			d="M6.75 9.75L8.29289 11.2929C8.68342 11.6834 9.31658 11.6834 9.70711 11.2929L11.25 9.75"
			stroke={iconColor}
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
		<path d="M9 11.25L9 2.25" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

export default DownloadIcon;
